export function initials(first = "", last = "") {
  return `${(first[0] || "").toUpperCase()}${(last[0] || "").toUpperCase()}` || "?";
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function fullName(u) {
  if (!u) return "Cornellian";
  return `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.email || "Cornellian";
}

export function memberTypeColor(type) {
  switch (type) {
    case "Current Student": return "bg-amber-50 text-amber-800";
    case "Young Alumni":    return "bg-emerald-50 text-emerald-800";
    case "Seasoned Alumni": return "bg-sky-50 text-sky-800";
    default: return "bg-neutral-100 text-neutral-700";
  }
}
